import { InfoOutlined } from '@mui/icons-material';
import { styled } from '@mui/material';

export const InfoStyled = styled(InfoOutlined)(({ theme }) => ({
  verticalAlign: 'middle',
  display: 'inline-flex',
  marginTop: -4,
  marginLeft: 5,
  color: theme.palette.text.secondary,
}));
